import React, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { FlexColumn } from 'styles/Layout';
import AuthenticationAction from 'actions/AuthenticationAction';
import HomieContext from 'HomieContext';
import { withRouter } from 'react-router-dom';
import { LoginDropDownOption, Divider } from './styles';
import { hasRoles } from 'modules/dashboards/utils/ValidateRole';

type PropsType = {
  currentUser: any,
  location: any,
  history: any
};

const AdminList = ({ currentUser, location, history }: PropsType) => {
  const { showLoadingProcessView } = useContext(HomieContext);

  const goToPage = (basePath: string): void => {
    history.push(basePath);
  };

  const AdditionalLoginOption = () => {
    if (!isEmpty(currentUser.currentAdminUser)) {
      return (
        <LoginDropDownOption onClick={() => onBackLogin()}>
          Regresar a {currentUser.currentAdminUser.name}
        </LoginDropDownOption>
      );
    }
    return (
      <LoginDropDownOption
        onClick={() => (window.location.href = '/admin_logins/new')}
      >
        Iniciar sesión como otro usuario
      </LoginDropDownOption>
    );
  };

  const onBackLogin = () => {
    showLoadingProcessView();
    AuthenticationAction.backLogin(response => {
      goToPage('/');
      location.reload();
    });
  };

  if (!hasRoles(currentUser, ['admin'])) {
    if (!isEmpty(currentUser.currentAdminUser)) {
      return (
        <LoginDropDownOption onClick={() => onBackLogin()}>
          Regresar a {currentUser.currentAdminUser.name}
        </LoginDropDownOption>
      );
    }
    return null;
  }

  return (
    <FlexColumn>
      <LoginDropDownOption onClick={() => (window.location.href = '/admin')}>
        Panel admin
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/homes/unapproved')}
      >
        Inmuebles por aprobar
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/homes/new')}
      >
        Crear inmueble
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/promotion_codes')}
      >
        Cupones
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/leads_offline')}
      >
        Leads offline Rentas
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/h/leads_offline_propietario')}
      >
        Leads offline Adq
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/h/financiamiento')}
      >
        Financiamiento
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/custom_zones')}
      >
        Zonas personalizadas
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/newsletters')}
      >
        Campañas
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() => (window.location.href = '/propietarios')}
      >
        Propietarios
      </LoginDropDownOption>
      <LoginDropDownOption
        onClick={() =>
          (window.location.href = '/dashboard/propietarios#/asignar-tarjeta')
        }
      >
        Asignar tarjeta de sr pago
      </LoginDropDownOption>
      <AdditionalLoginOption />
      <Divider />
      <LoginDropDownOption
        onClick={() => (window.location.href = '/home_applications')}
      >
        Aplicaciones
      </LoginDropDownOption>
    </FlexColumn>
  );
};

AdminList.displayName = 'AdminList';
export default withRouter(AdminList);
